import logger from "@insite/client-framework/Logger";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    userName: state.context.session.userName,
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    currentLocation: getLocation(state),
});

type Props = ReturnType<typeof mapStateToProps> & HasHistory;

export interface SignInForPricingStyles {
    titleClickable?: ClickablePresentationProps;
}

export const styles: SignInForPricingStyles = {
    titleClickable: {
        css: css`
            justify-content: center;
            position: relative;
            width: 100%;
            svg {
                width: 26px;
                background: #fff;
                padding: 5px;
                position: relative;
                z-index: 2;
            }
            span {
                position: relative;
                z-index: 2;
                padding-right: 5px;
                background: #fff;
            }
            &:after {
                content: "";
                width: 100%;
                border-top: 1px solid #b0b0b0;
                position: absolute;
                top:50%;
                transform: translateY(-50%);
            }
        `,
    },
};

const SignInForPricing = ({
    userName,
    signInUrl,
    currentUserIsGuest,
    currentLocation,
    history }: Props) => {

    const onSignInHandler = () => {
        if (!userName || currentUserIsGuest) {
            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
            } else {
                const returnUrl = currentLocation.pathname + currentLocation.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
            }
        }
    };

    return (
        <Clickable {...styles.titleClickable} onClick={onSignInHandler} data-test-selector="productPrice_signIn">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" className="svg-inline--fa fa-user-circle fa-w-16" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
            <Typography>{siteMessage("Pricing_SignInForPrice")}</Typography>
        </Clickable>
    );
}
export default connect(mapStateToProps)(withHistory(SignInForPricing));